import { c as _c } from "react/compiler-runtime";
import { openWindowSafely } from '@systemeio/util';
import StudentProgressExportNotificationItem from 'modules/courses/students/components/student-progress-export-notification-item';
import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum';
import SharingNotificationItem from 'modules/share/components/sharing-notification-item';
import { type ActionMenuItemProps } from 'shared/components';
import { getNotificationIcon } from '../constants/notification-icons';
import { useNotificationsActions } from '../hooks/use-notification-actions';
import type { NotificationBaseItemInterface } from '../types/base-notification-interface';
import type { NotificationItemInterface } from '../types/notification-types';
import { NotificationItemView, type NotificationItemVariant } from './notification-item-view';
export interface BaseNotificationProps {
  notification: NotificationBaseItemInterface;
  actions?: ActionMenuItemProps[];
  variant?: NotificationItemVariant;
  onNavigate?: () => void;
}
const BaseNotificationItem = ({
  actions,
  notification,
  variant,
  onNavigate
}: BaseNotificationProps) => {
  const {
    getNotificationLink
  } = useNotificationsActions();
  const handleNotificationClick = async () => {
    const safeWindow = openWindowSafely();
    try {
      const {
        link
      } = await getNotificationLink(notification.id);
      safeWindow.navigate(link);
      onNavigate?.();
    } catch (error) {
      safeWindow.close();
      throw error;
    }
  };
  return <NotificationItemView variant={variant} isRead={notification.read} actions={actions} icon={getNotificationIcon(notification)} message={notification.message} time={notification.createdAt} onClick={handleNotificationClick} />;
};
export interface NotificationItemProps {
  notification: NotificationItemInterface;
  actions?: ActionMenuItemProps[];
  variant?: NotificationItemVariant;
  /** Called when the notification opens its target, so an overlay host can close itself. */
  onNavigate?: () => void;
}
export const NotificationItem = t0 => {
  const $ = _c(14);
  const {
    actions,
    notification,
    variant,
    onNavigate
  } = t0;
  switch (notification.eventType) {
    case NotificationTypeEnum.StudentProgressExport:
      {
        let t1;
        if ($[0] !== actions || $[1] !== notification || $[2] !== variant) {
          t1 = <StudentProgressExportNotificationItem notification={notification} actions={actions} variant={variant} />;
          $[0] = actions;
          $[1] = notification;
          $[2] = variant;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case NotificationTypeEnum.SharingStarted:
      {
        let t1;
        if ($[4] !== actions || $[5] !== notification || $[6] !== onNavigate || $[7] !== variant) {
          t1 = <SharingNotificationItem notification={notification} actions={actions} variant={variant} onNavigate={onNavigate} />;
          $[4] = actions;
          $[5] = notification;
          $[6] = onNavigate;
          $[7] = variant;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[9] !== actions || $[10] !== notification || $[11] !== onNavigate || $[12] !== variant) {
          t1 = <BaseNotificationItem notification={notification} actions={actions} variant={variant} onNavigate={onNavigate} />;
          $[9] = actions;
          $[10] = notification;
          $[11] = onNavigate;
          $[12] = variant;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
  }
};